import React, { FunctionComponent, useEffect } from 'react';
import Head from 'next/head';
import { CustomWindow } from '../../types';
import { useRouter } from 'next/router';
import { sanitizeHtml } from '../../utils/text';

const tbearsToken = 'cb25f9075f844a6f9013071c56575307';
declare const window: CustomWindow;

export const TBears: FunctionComponent = () => {
  const { locale } = useRouter();
  useEffect(() => {
    window?.TB_LOGS?.onReady(() => {
      window.TB_LOGS.setUser({
        locale,
      });
    });
  }, [locale]);

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html:
            sanitizeHtml(`(function(b,e,a,r,s) { b=b[s]=b[s]||{q:[],onReady:function(c){b.q.push(c)}}; s=e.createElement(a);s.async=1;s.src=r; r=e.getElementsByTagName(a)[0];r.parentNode.insertBefore(s,r)
          })(window,document,'script','/en/3bears.js','TB_LOGS')
          TB_LOGS.onReady(function(){ TB_LOGS.init({
          clientToken: "${tbearsToken}", })})`),
        }}
        defer
      />
    </Head>
  );
};
